export default __webpack_public_path__ + "static/media/thomas.994eeac4.jfif";